<template>
  <div class="print-break-after measures-sheet-container">
    <!-- 
      Div principale, gestione spesa mediante modal
    -->
    <div v-show="tabToShow === 'default'" class="wg-row">
      <div class="wg-col wg-xs-5">
        <div
          style="font-size:17px;"
          class="com-anm22-app-text-m suit-model"
        >{{$anm22.strLang(lang, "Model","Modello")}}</div>
        <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
        <select
          v-if="mode === 'edit'"
          class="input-elem com-anm22-app-select"
          v-model="sheetData.sizeSelected"
        >
          <option
            v-for="(size,index) in sizes"
            :key="'modelsize-'+index"
            :value="size.idVircosModelsBase"
          >{{ size.modelName}}</option>
        </select>
        <span class="input-text com-anm22-app-text-m" v-else>{{modelSelected.modelName}}</span>
      </div>
      <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
      <div style="height:30px;position:relative;" class="wg-row">
        <div
          class="wg-col wg-xs-2"
          style="position:relative;left:25%;width:15%;"
          v-for="(label,index) in labels"
          :key="'label'+index"
        >
          <div
            style="text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"
            class="com-anm22-app-text-m"
          >{{ label.labelName}}</div>
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-row input-row measure" v-for="(input,index) in fields" :key="'input'+index">
          <div class="wg-col wg-xs-1">
            <div class="com-anm22-app-text-m">{{ index + 1 }}</div>
          </div>
          <div class="wg-col wg-xs-2">
            <div
              style="overflow-wrap:break-word;"
              class="input-text com-anm22-app-text-m print-text"
            >{{ input.label }}</div>
          </div>
          <div class="wg-col wg-xs-2">
            <input
              v-if="input.name == 'manica-piegata-totale'"
              disabled
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="sommaManicaPiegataTot"
            />
            <input
              v-else
              disabled
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              v-model="misures[input.name]"
            />
          </div>

          <div class="com-anm22-horizontal-div" style="width: 2px;"></div>
          <div class="wg-col wg-xs-2">
            <input
              :disabled="mode === 'view'"
              class="input-elem print-elem com-anm22-app-input-text"
              type="number"
              v-model="vestib[input.name]"
            />
          </div>
          <div class="com-anm22-horizontal-div" style="width:2px;"></div>
          <div class="wg-col wg-xs-2">
            <input
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
              disabled
              :value="totalMisures(input.name)"
            />
          </div>
          <div class="com-anm22-horizontal-div" style="width: 2px;"></div>
          <div class="wg-col wg-xs-2">
            <input
              disabled
              v-model="modelSelected.modelSizes[input.name]"
              class="input-elem print-elem com-anm22-app-input-text"
              type="text"
            />
          </div>
          <div class="com-anm22-horizontal-div" style="width: 2px;"></div>
          <div class="wg-col wg-xs-2">
            <input
              disabled
              :value="differenceSize(input.name)"
              class="input-elem print-elem com-anm22-app-input-text"
              type="number"
            />
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:40px;">&nbsp;</div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'Last edit', 'Ultima modifica') }}</div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ lastEditDate + ' ' + lastEditUser }}</div>
        </div>
      </div>
      <template v-if="mode === 'edit'">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input type="button" :value="$anm22.strLang(lang, 'Save', 'Salva')" @click="saveForm" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    sizes: Array,
    mode: {
      type: String,
      default: "edit"
    }
  },
  data() {
    return {
      // Misure
      misures: {},
      //Scheda con i vari dati(salviamo solo la vestibilità e il modello selezionato ,gli altri dati sono dati derivati)
      sheetData: {
        sizeSelected: "",
        vestibility: {}
      },
      vestib: {},
      modelSelected: {
        modelSizes: {}
      },
      tabToShow: "default",
      picToShow: null,
      labels: [
        {
          labelName: this.$anm22.strLang(this.lang, "Misure", "Measures")
        },
        {
          labelName: this.$anm22.strLang(
            this.lang,
            "Vestibilità",
            "Vestibility"
          )
        },
        {
          labelName: this.$anm22.strLang(this.lang, "Totale", "Total")
        },
        {
          labelName: this.$anm22.strLang(this.lang, "Taglie", "Sizes")
        },
        {
          labelName: this.$anm22.strLang(this.lang, "Diff", "Diff")
        }
      ],
      fields: [
        {
          name: "punto-spalla",
          label: "Punto spalle"
        },
        {
          name: "circ-torace",
          label: "Circonferenza torace"
        },
        {
          name: "circ-vita",
          label: "Circonferenza vita"
        },
        {
          name: "circ-bacino",
          label: "Circonferenza bacino"
        },
        {
          name: "da-pv-a-ginocchio",
          label: "Da punto vita a centro ginocchio"
        },
        {
          name: "da-pv-a-caviglia",
          label: "Da punto vita a caviglia"
        },
        {
          name: "da-pv-a-terra",
          label: "Da punto vita a terra"
        },
        {
          name: "da-cavallo-a-ginocchio",
          label: "Da cavallo a centro ginocchio"
        },
        {
          name: "manica-spalla-gomito",
          label: "Lunghezza manica da spalla a centro gomito"
        },
        {
          name: "manica-gomito-fondo",
          label: "Lunghezza manica da centro gomito a fondo"
        },
        {
          name: "circ-braccio",
          label: "Circonferenza braccio"
        },
        {
          name: "circ-avanbraccio",
          label: "Circonferenza avanbraccio"
        },
        {
          name: "circ-polso",
          label: "Circonferenza polso"
        },
        {
          name: "circ-coscia",
          label: "Circonferenza coscia"
        },
        {
          name: "circ-ginocchio",
          label: "Circonferenza ginocchio"
        },
        {
          name: "circ-polpaccio",
          label: "Circonferenza polpaccio"
        },
        {
          name: "circ-caviglia",
          label: "Circonferenza caviglia"
        },
        {
          name: "lung-vita",
          label: "Lunghezza vita"
        },
        {
          name: "altezza",
          label: "Altezza cm"
        },
        {
          name: "peso",
          label: "Peso kg"
        },
        {
          name: "",
          label: ""
        },
        {
          name: "manica-piegata-totale",
          label: "10+9 lunghezza manica piegata totale"
        },
        {
          name: "centro-davanti",
          label: "Centro davanti"
        },
        {
          name: "lung-fianco",
          label: "Lunghezza fianco"
        },
        {
          name: "ovetto",
          label: "Ovetto"
        },
        {
          name: "tratta-davanti",
          label: "Tratta davanti"
        },
        {
          name: "tratta-dietro",
          label: "Tratta dietro"
        },
        {
          name: "circ-collo",
          label: "Circonferenza collo"
        },
        {
          name: "circ-gomito",
          label: "Circonferenza gomito"
        },
        {
          name: "punto-seno",
          label: "Punto seno (donna)"
        },
        {
          name: "dist-seni",
          label: "Distanza seni (donna)"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }),
    sommaManicaPiegataTot() {
      if (
        !this.misures["manica-spalla-gomito"] &&
        this.misures["manica-gomito-fondo"]
      ) {
        return this.misures["manica-gomito-fondo"];
      } else if (
        this.misures["manica-spalla-gomito"] &&
        !this.misures["manica-gomito-fondo"]
      ) {
        return this.misures["manica-spalla-gomito"];
      } else if (
        !this.misures["manica-spalla-gomito"] &&
        !this.misures["manica-gomito-fondo"]
      ) {
        return;
      }
      return (
        Number(this.misures["manica-spalla-gomito"]) +
        Number(this.misures["manica-gomito-fondo"])
      );
    },
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.sheetData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.sheetData.lastUpdate
        ? this.$moment
            .unix(this.sheetData.lastUpdate)
            .format("DD/MM/YYYY HH:mm")
        : "";
    }
  },
  watch: {
    "sheetData.sizeSelected": function(newVal) {
      this.$vlf("vircos-models-base")
        .getItem(String(this.sheetData.sizeSelected))
        .then(result => {
          if (result) {
            this.modelSelected = result;
          }
        });
    }
  },
  methods: {
    saveForm() {
      const docs = { ...this.docs };
      docs.measuresSheet = this.sheetData;
      docs.measuresSheet.lastUser = this.user.idWorldUser;
      docs.measuresSheet.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    //Totale tra misura e vestibilità
    totalMisures(input) {
      let misure;
      let vestibility = Number(this.vestib[input]);
      if (input == "manica-piegata-totale") {
        misure = this.sommaManicaPiegataTot;
      } else {
        misure = Number(this.misures[input]);
      }
      if (!vestibility && misure) {
        return misure;
      } else if (!misure) {
        return "";
      } else if (misure && vestibility) {
        let tot = misure + vestibility;
        return Math.round(tot * 10) / 10;
      }
    },
    //Differenza tra totale e taglia
    differenceSize(input) {
      let size = Number(this.modelSelected.modelSizes[input]);
      let total = this.totalMisures(input);
      if (!size) {
        return 0;
      } else {
        let diff = total - size;
        return Math.round(diff * 10) / 10;
      }
    }
  },
  created() {
    this.misures = { ...this.docs.measures };
    //creo l'oggetto vestibility in caso non sia presente
    this.sheetData = { ...this.docs.measuresSheet };
    if (!this.sheetData.vestibility || this.sheetData.vestibility.length == 0) {
      this.sheetData.vestibility = {
        "punto-spalla": 4,
        "circ-torace": 10,
        "circ-vita": 10,
        "circ-bacino": 4,
        "da-pv-a-ginocchio": 0,
        "da-pv-a-caviglia": 4,
        "da-pv-a-terra ": 0,
        "da-cavallo-a-ginocchio": 0,
        "manica-spalla-gomito": 2,
        "manica-gomito-fondo": 2,
        "circ-braccio": 0,
        "circ-avanbraccio": 6,
        "circ-polso": 2,
        "circ-coscia": 0,
        "circ-ginocchio": 4,
        "circ-polpaccio": 6,
        "circ-caviglia": 3,
        "lung-vita": 5,
        altezza: 0,
        peso: 0,
        ovetto: 5,
        "circ-gomito": 6
      };
    }
    this.vestib = this.sheetData.vestibility;
  }
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.input-text {
  padding-left: 10px;
}
.input-elem {
  width: 100%;
  max-width: 200px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.pic-viewer {
  height: calc(90vh - 90px);
  width: 100%;
  justify-content: center;
}
@media print {
  .input-row.measure {
    margin: 0;
    height: 28px;
    input {
      height: 28px;
      padding: 5px 10px;
    }
  }
  .print-break-after {
    break-after: page;
  }
}
</style>
